import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';

import { formatDateMed } from 'src/lib/format';

export const getPercentView = (value) =>
  value !== null ? Math.round(value * 100) / 100 : null;

export const calculateCtrPercent = ({ clicks, views } = {}) => {
  if (clicks === null || views === null) {
    return null;
  }

  return views !== 0 ? (100 * clicks) / views : 0;
};

export const prepareCampaignPerformanceData = (rawData) => {
  const sorted = orderBy(rawData, ['dateTime'], ['asc']);
  const groupedByDate = groupBy(sorted, 'dateTime');

  return Object.entries(groupedByDate).map(([dateTime, rows]) => {
    const originalRow = rows.find((r) => !r.isTraffic);
    const originalCtr = calculateCtrPercent(originalRow);

    const campaignRow = rows.find((r) => r.isTraffic);
    const campaignCtr = calculateCtrPercent(campaignRow);

    return {
      name: formatDateMed(dateTime),
      original: {
        ctr: originalCtr,
        views: originalRow ? originalRow.views : null,
        clicks: originalRow ? originalRow.clicks : null,
      },
      anyword: {
        ctr: campaignCtr,
        views: campaignRow ? campaignRow.views : null,
        clicks: campaignRow ? campaignRow.clicks : null,
      },
    };
  });
};

export const orderCOAssets = (assets) =>
  orderBy(assets, ['selectedAtNanoTimestamp', 'createdAt', 'id']);

export const getOriginVariantText = (asset) => {
  const { savedVariation } =
    asset.variants.find((variant) => variant.isOrigin) || null;
  return (savedVariation && savedVariation.text) || '';
};

export const getOriginVariant = (asset) => {
  const origin = asset.variants.find((variant) => variant.isOrigin) || null;
  const { savedVariation } = origin;
  return (
    (savedVariation && {
      copyText: savedVariation.text,
      score: savedVariation.score,
    }) || {
      copyText: '',
      score: '',
    }
  );
};
